__webpack_require__.p = "https://lijc.rightinthebox.com/promotion_src/public/optimus-v2-litb/_next/";